export default "__VITE_ASSET__CfUU8b5k__"